// extracted by mini-css-extract-plugin
export const share = "Share-module--share--PvHMN";
export const share_social = "Share-module--share_social--2iRz5";